import script from "./AdminDeliveryOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDeliveryOptions.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__